// extracted by mini-css-extract-plugin
module.exports = {"divCard":"building-schedule_divCard_22d--","head":"building-schedule_head__LOvc","text":"building-schedule_text_t7KlS","icon":"building-schedule_icon_26_CX"};